import { Col, Row } from 'react-bootstrap'
import styles from './ErrorMessage.module.css'

interface errorMessageProps {
    message: string
}

export default function ErrorMessage({message}: errorMessageProps) {
    return (
        <Row className={`${styles.container} alert alert-danger`}>
            <Col>
                {message}
            </Col>
        </Row>
    )
}